import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionCard } from "@/components/studio/SectionCard";
import { ChapterArt, ChapterArtBar } from "@/components/studio/ChapterArt";

const ROMAN = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII", "XIV", "XV", "XVI", "XVII", "XVIII", "XIX", "XX"];

export const ChaptersView = ({ p, theme, onChange, onMove, onDelete, onAdd, ensureSaved, onOpenAI, onArtStarted, onArtChanged }) => {
  const [sel, setSel] = useState(0);
  const sections = p.sections || [];
  const i = Math.min(sel, Math.max(0, sections.length - 1));
  const s = sections[i];

  if (!sections.length)
    return (
      <div className="bg-[#FFFDF9] border border-dashed p-10 text-center" style={{ borderColor: theme.accent }}>
        <p className="font-body-serif italic text-lg text-[#5C5255]">An empty manuscript.</p>
        <div className="flex gap-3 justify-center mt-4">
          <Button className="rounded-none" style={{ background: theme.dark }} onClick={onOpenAI} data-testid="empty-open-ai-btn">Let the AI write or convert it</Button>
          <Button variant="outline" className="rounded-none bg-transparent" onClick={onAdd} data-testid="add-section-btn">Add a chapter</Button>
        </div>
      </div>
    );

  return (
    <div data-testid="chapters-view">
    <ChapterArtBar p={p} theme={theme} ensureSaved={ensureSaved} onStarted={onArtStarted} />
    <div className="grid lg:grid-cols-12 gap-8">
      <div className="lg:col-span-3">
        <ul className="space-y-1">
          {sections.map((c, j) => (
            <li key={c.id}>
              <button onClick={() => setSel(j)} className="w-full text-left flex gap-3 px-3 py-2 text-sm transition-colors" style={j === i ? { background: theme.dark, color: "#F3EBD6" } : {}} data-testid={`chapter-nav-${j}`}>
                <span className="font-playfair italic w-8 shrink-0" style={{ color: theme.accent }}>{ROMAN[j] || j + 1}.</span>
                <span className="truncate">{c.heading}</span>
              </button>
            </li>
          ))}
        </ul>
        <Button variant="ghost" className="rounded-none gap-1.5 mt-3 w-full justify-start" onClick={() => { onAdd(); setSel(sections.length); }} data-testid="add-section-btn"><Plus size={14} /> Add a chapter</Button>
      </div>
      <div className="lg:col-span-9 min-w-0">
        <div className="px-8 py-8 mb-5 flex flex-col sm:flex-row sm:items-center gap-6" style={{ background: theme.dark }} data-testid="chapter-banner">
          <div className="flex-1 min-w-0">
            <div className="font-playfair text-5xl" style={{ color: theme.accent }}>{ROMAN[i] || i + 1}</div>
            <div className="font-playfair text-3xl sm:text-4xl text-[#F3EBD6] mt-3">{s.heading}</div>
          </div>
          <ChapterArt p={p} s={s} theme={theme} ensureSaved={ensureSaved} onStarted={onArtStarted} onChanged={onArtChanged} />
        </div>
        <SectionCard key={s.id} index={i} total={sections.length} section={s} productId={p.id} defaultOpen
          onChange={(ns) => onChange(i, ns)} onMove={(d) => { onMove(i, d); setSel(i + d); }} onDelete={() => { onDelete(i); setSel(Math.max(0, i - 1)); }} ensureSaved={ensureSaved} />
      </div>
    </div>
    </div>
  );
};
